import styled from "styled-components";


export const Wrapper = styled.div`
margin-bottom: 38px;
.carousel-item {
    > img {
    width: 100%;
    height: 540px;
    object-fit: cover;
    }
}
`;
